var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5859 24.3333L33.6264 31.2929L32.9193 32L33.6264 32.7071L38.2931 37.3738L39.0002 38.0809L39.7073 37.3738L56.3739 20.7071L57.081 20L56.3739 19.2929L39.7073 2.62622L39.0002 1.91911L38.2931 2.62622L33.6264 7.29289L32.9193 8L33.6264 8.7071L40.5859 15.6667H22.0002C16.3723 15.6667 11.5054 17.5029 7.45355 21.1758C3.38283 24.8658 1.3335 29.4962 1.3335 35C1.3335 40.5038 3.38283 45.1342 7.45355 48.8242C11.5054 52.4971 16.3723 54.3333 22.0002 54.3333H45.6668H46.6668V53.3333V46.6667V45.6667H45.6668H22.0002C18.7324 45.6667 15.9239 44.6368 13.5273 42.5752C11.1591 40.5381 10.0002 38.0346 10.0002 35C10.0002 31.9653 11.1591 29.4619 13.5273 27.4248C15.9239 25.3632 18.7324 24.3333 22.0002 24.3333H40.5859Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_9007",
    x1: 2.3335,
    y1: 28.3333,
    x2: 55.6668,
    y2: 28.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B316A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_9007",
    x1: 2.3335,
    y1: 28.3333,
    x2: 55.6668,
    y2: 28.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A5CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B316A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.80b8e877bcaa2c524d21766f2d80ab7a.svg";
export { ForwardRef as ReactComponent };